import moment from 'moment'

export const global_map_response = {
    eventWithShop: {
        fame_points: 12345,
        context_id: 'Soldiers of Fortune',
        personal_bonuses_enabled: true,
        event_rewards_enabled: true,
        battle_schedule_enabled: true,
        leaderboards_enabled: true,
        nearest_battle: {
            starts_at: moment().add(1, 'minute').unix().valueOf(),
            is_planned: true,
        },
    },
    eventWithoutShop: {
        fame_points: 12345,
        context_id: 'Soldiers of Fortune',
        personal_bonuses_enabled: false,
        event_rewards_enabled: true,
        battle_schedule_enabled: true,
        leaderboards_enabled: true,
    },
    noEvent: {
        fame_points: null,
        context_id: null,
        personal_bonuses_enabled: false,
        event_rewards_enabled: true,
        battle_schedule_enabled: true,
        leaderboards_enabled: true,
    },
}

export const craft_machine_response = {
    is_craft_machine_enabled: false,
    is_enhancements_enabled: false,
    webbrg_content_url: 'https://webbrg.worldoftanks.ru/ru/promocontent/referral/',
}



// WEBPACK FOOTER //
// ./state/__mocks__/clan_landing_mock.js